import { zendeskQueries } from '@/features/zendesk-app'
import { useQuery } from '@tanstack/react-query'
import { ArrayHelpers } from 'formik'
import { Option } from '@/components/ui/Autocomplete/Autocomplete.types'
import React from 'react'

export const curryAddNewView = <T extends any[]>(helpers: ArrayHelpers<T>) => {
  // TODO Add default slack message
  return () =>
    helpers.push({
      view: '',
      threshold: 5,
      slackUrl: '',
    } as T[number])
}

export const useViewOptions = (): Option[] => {
  const query = useQuery({
    ...zendeskQueries.views.list(),
  })

  return React.useMemo(
    () =>
      query.data?.views.map((view) => ({
        label: view.title,
        value: view.id,
      })) ?? [],
    [query.data]
  )
}
